<template>
  <div class="container">
    <div class="survey-title mb40 has-text-centered">Which <span class="highlight-text">flavours</span> do
      you prefer?</div>
    <div class="fields-block mb60">
      <h3 class="title has-text-centered">Select as many as you like.</h3>
      <div class="columns justify-content-center">
        <div class="column">
          <div
            class="field is-grouped is-flex-tablet justify-content-center align-items-center is-flex-wrap">
            <div class="control mr5 ml5 mb10 has-text-centered">
              <div class="pref-block">
                <input v-model="flavour" value="Earthy" class="is-checkradio is-block" id="pref-flavour-earthy" type="checkbox"
                  name="pref-flavour">
                <label for="pref-flavour-earthy"
                  class="is-flex is-flex-column align-items-center justify-content-center">
                  <img src="@/assets/img/icon-earthy.svg" alt="" class="mb10">
                  <h4 class="pref-label">Earthy</h4>
                </label>
              </div>
              <p class="mt15 flavour-example">e.g. Wood, Pine, Earth</p>
            </div>
            <div class="control mr5 ml5 mb10 has-text-centered">
              <div class="pref-block">
                <input v-model="flavour" value="Spicy" class="is-checkradio is-block" id="pref-flavour-spicy" type="checkbox"
                  name="pref-flavour">
                <label for="pref-flavour-spicy"
                  class="is-flex is-flex-column align-items-center justify-content-center">
                  <img src="@/assets/img/icon-spicy.svg" alt="" class="mb10">
                  <h4 class="pref-label">Spicy</h4>
                </label>
              </div>
              <p class="mt15 flavour-example">e.g. Pepper, Spices, Cloves</p>
            </div>
            <div class="control mr5 ml5 mb10 has-text-centered">
              <div class="pref-block">
                <input v-model="flavour" value="Sweet" class="is-checkradio is-block" id="pref-flavour-sweet" type="checkbox"
                  name="pref-flavour">
                <label for="pref-flavour-sweet"
                  class="is-flex is-flex-column align-items-center justify-content-center">
                  <img src="@/assets/img/icon-sweet.svg" alt="" class="mb10">
                  <h4 class="pref-label">Sweet</h4>
                </label>
              </div>
              <p class="mt15 flavour-example">e.g. Florals, Fruit, Apples</p>
            </div>
            <div class="control mr5 ml5 mb10 has-text-centered">
              <div class="pref-block">
                <input v-model="flavour" value="Citrus" class="is-checkradio is-block" id="pref-flavour-citrus" type="checkbox"
                  name="pref-flavour">
                <label for="pref-flavour-citrus"
                  class="is-flex is-flex-column align-items-center justify-content-center">
                  <img src="@/assets/img/icon-citrus.svg" alt="" class="mb10">
                  <h4 class="pref-label">Citrus</h4>
                </label>
              </div>
              <p class="mt15 flavour-example">e.g. Lemon, Lime, Oranges</p>
            </div>
            <div class="control mr5 ml5 mb10 has-text-centered">
              <div class="pref-block">
                <input v-model="flavour" value="Herbal" class="is-checkradio is-block" id="pref-flavour-herbal" type="checkbox"
                  name="pref-flavour">
                <label for="pref-flavour-herbal"
                  class="is-flex is-flex-column align-items-center justify-content-center">
                  <img src="@/assets/img/icon-herbal.svg" alt="" class="mb10">
                  <h4 class="pref-label">Herbal</h4>
                </label>
              </div>
              <p class="mt15 flavour-example">e.g. Mint, Tea, Basil</p>
            </div>
          </div>
        </div>
      </div>

      </p>
    </div>
    <div class="steps mt100 mb50">
      <ul class="is-flex justify-content-around">
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class="mr0"></li>
      </ul>
    </div>
    <div class="next-button is-flex align-items-center justify-content-center has-text-centered mb50">
      <a href="#" @click.prevent="back()" 
        class="back-btn is-primary is-hidden-mobile mr40 m0-xs">Back</a>
      <a href="#" @click.prevent="next()" class="button is-primary ml40 is-marginless-tablet">Next</a>
    </div>
    <div
      class="skip-button is-flex-mobile align-items-center justify-content-between has-text-centered mb30">
      <a href="#" @click.prevent="back()" class="back-btn is-primary is-hidden-tablet">Back</a>
      <a href="#" @click.prevent="setStep(7)" class="is-primary">Skip</a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      flavour: [],
    };
  },
  computed: {
    ...mapGetters({
      step: "usersurvey/step"
    })
  },
  methods: {
    /**
     * Step back
     */
    back() {
      this.setStep(5);
      this.setSurvey({
        productKind: [],
      })
    },

    /**
     * Next step 
     */
    next() {
      if(this.flavour == '') {
        this.setSnackbar({
          modal: true,
          message: 'Please select flavours you prefer.',
          type: 'warning',
        }) 
      } else {
        this.setSurvey({
          flavour: this.flavour
        })
        this.setStep(7);
      }
    },
    ...mapActions({
      setSnackbar: "snackbar/setSnackbar",
      setStep: "usersurvey/setStep",
      setSurvey: "usersurvey/setSurvey"
    })
  },
};
</script>